import PropTypes from "prop-types";
// @mui
import { styled } from "@mui/material/styles";
import { Box, Stack, AppBar, Toolbar, IconButton } from "@mui/material";
// components
import Iconify from "../../../components/iconify";
//
import AccountPopover from "./AccountPopover";
import Searchbar from "../header/Searchbar";
import NotificationsPopover from "../header/NotificationsPopover";
import { useColorMode } from "../../../theme";

// ─────────────────────────────────────────────────────────────────────────────

const NAV_WIDTH = 260;

const HEADER_MOBILE = 56;

const HEADER_DESKTOP = 64;

// SFM dark-slate chrome on top app bar.
// Matches sidebar Drawer paper (#1D2330) so the chrome reads as a single surface.
const StyledRoot = styled(AppBar)(({ theme }) => ({
  backgroundColor: "#1D2330",
  backgroundImage: "none",
  color: "#FFFFFF",
  borderBottom: "1px solid rgba(255,255,255,0.06)",
  boxShadow: "0 1px 12px rgba(0,0,0,0.20)",
  [theme.breakpoints.up("lg")]: {
    width: `calc(100% - ${NAV_WIDTH + 1}px)`,
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up("lg")]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 3),
  },
}));

// ----------------------------------------------------------------------

Header.propTypes = {
  onOpenNav: PropTypes.func,
};

export default function Header({ onOpenNav }) {
  const { mode, toggleColorMode } = useColorMode();

  return (
    <StyledRoot>
      <StyledToolbar>
        <IconButton
          onClick={onOpenNav}
          sx={{
            mr: 1,
            // On dark-slate chrome, hamburger must be white not text.primary
            color: "#FFFFFF",
            display: { lg: "none" },
          }}
        >
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>

        <Searchbar />
        <Box sx={{ flexGrow: 1 }} />

        <Stack
          direction="row"
          alignItems="center"
          spacing={{
            xs: 0.5,
            sm: 1,
          }}
        >
          {/* <LanguagePopover /> */}
          <IconButton
            onClick={toggleColorMode}
            aria-label="Toggle light / dark mode"
            sx={{ color: "#FFFFFF" }}
          >
            <Iconify icon={mode === "dark" ? "eva:sun-outline" : "eva:moon-outline"} />
          </IconButton>
          <NotificationsPopover />
          <AccountPopover />
        </Stack>
      </StyledToolbar>
    </StyledRoot>
  );
}
